module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video",
    class: {
      expanded: _vm.isPlaying
    }
  }, [_c('youtube', {
    class: 'iframe-wrap',
    attrs: {
      "video-id": _vm.videoId,
      "player-width": "100%",
      "player-height": "100%"
    },
    on: {
      "playing": _vm.playing,
      "buffering": _vm.playing,
      "ended": _vm.paused,
      "paused": _vm.paused
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-87ac1ad2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/YoutubeVideo.vue
// module id = 1182
// module chunks = 2